"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundsModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const refund_entity_1 = require("./refund.entity");
const refunds_service_1 = require("./refunds.service");
const refunds_controller_1 = require("./refunds.controller");
let RefundsModule = class RefundsModule {
};
exports.RefundsModule = RefundsModule;
exports.RefundsModule = RefundsModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forFeature([refund_entity_1.Refund])],
        providers: [refunds_service_1.RefundsService],
        controllers: [refunds_controller_1.RefundsController],
        exports: [refunds_service_1.RefundsService],
    })
], RefundsModule);
